<div class="dashboard-tile" [id]="'contentToConvert-' + metadata?.KPI">
  <div class="title-and-cog-row">
    <tile-title
      [title]="data?.title"
      [definition]="data?.definition"
      [source]="data?.source"
      [level]="level"
      display="right"
      *ngIf="level === 'usage' && data"
      class="tile-title-block"
    ></tile-title>
    <tile-title
      [title]="metadata?.title"
      [source]="data?.source"
      [definition]="data?.definition"
      [level]="level"
      *ngIf="level !== 'student' && level !== 'usage'"
      class="tile-title-block"
    ></tile-title>
    <div class="buttons">
      <div
        class="cog"
        *ngIf="role == 'admin' && metadata && level !== 'student'"
      >
        <a
          [routerLink]="getRouteForCog(metadata.KPI)"
          title="Navigate to Metric Settings"
        >
          <div class="cog-img" alt="Navigate to Metric Settings"></div>
        </a>
      </div>
      <div *ngIf="metadata && metadata.KPI && metadata.title">
        <a
          class="btn btn-link download-btn"
          (click)="captureScreen(metadata.KPI, metadata.title)"
          title="Download tile"
        >
          <div class="download-img" alt="Download tile"></div>
        </a>
      </div>
    </div>
  </div>
  <div class="tile-body" *ngIf="!loading && data">
    <div class="subtitle" *ngIf="data.charts[data.selectedChart]?.subtitle">
      <h5 class="tile-timeframe" *ngIf="isFreckleMetric">
        Last 28 days ({{ data.charts[data.selectedChart]?.subtitle }})
      </h5>
      <h5 class="tile-timeframe" *ngIf="!isFreckleMetric">
        {{ data.charts[data.selectedChart]?.subtitle }}
      </h5>
    </div>
    <div
      class="goal"
      *ngIf="
        level !== 'student' &&
        level !== 'usage' &&
        data.selectedChart != 'calendar'
      "
    >
      <div
        class="overall-data number_small"
        [style.color]="data.overallColor"
        *ngIf="data.selectedChart != 'overall' && data.overall"
      >
        <span class="prefix_small" [style.color]="data.overallColor">{{
          data.dataPrefix
        }}</span
        >{{ data.overall | number
        }}<span class="number_small" [style.color]="data.overallColor">{{
          data.dataSuffix
        }}</span>
      </div>
      <div
        class="overall-text label"
        *ngIf="data.selectedChart != 'overall' && data.overall"
      >
        {{ data.overallSubtitle }}
      </div>

      <div
        *ngIf="
          data.selectedChart == 'overall' &&
          data.charts.overall &&
          data.charts.overall.chartData
        "
      >
        <div class="overall-goal number_small" *ngIf="data.goalNumeric != null">
          {{ data.goalText }}
        </div>
        <div
          class="overall-text label"
          *ngIf="data.goalNumeric != null && level == 'district'"
        >
          {{ data.goalSubtitle }}
        </div>
        <div
          class="overall-text label"
          *ngIf="data.goalNumeric != null && level != 'district'"
        >
          school goal
        </div>
        <div
          class="overall-text label no-goal"
          *ngIf="data.goalNumeric == null"
        >
          <a
            [routerLink]="getRouteForCog(metadata.KPI)"
            *ngIf="role == 'admin'"
            title="Set goal in Metric Settings"
            class="settings-link"
          >
            <em *ngIf="level == 'district'">No district goal set</em>
            <em *ngIf="level != 'district'">No school goal set</em>
          </a>
          <ng-container *ngIf="role != 'admin'">
            <em *ngIf="level == 'district'">No district goal set</em>
            <em *ngIf="level != 'district'">No school goal set</em>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      class="row dropdown-row-and-chart-goal"
      *ngIf="
        level !== 'student' &&
        level !== 'usage' &&
        data.selectedChart != 'calendar'
      "
    >
      <div
        class="dropdown-row"
        *ngIf="
          data.selectedChart == 'characteristic' ||
          data.selectedChart == 'topBottomRank'
        "
      >
        <div
          *ngIf="
            data.selectedChart == 'characteristic' &&
            data.charts.characteristic.chartData
          "
          class="dropdown-and-info"
        >
          <ng-select
            [items]="categories"
            [(ngModel)]="selectedCategory"
            placeholder="Select a category"
            [clearable]="false"
            [searchable]="false"
            class="chart-select"
          ></ng-select>
          <!-- display info image w/ tooltip if selected category filters by currently enrolled students-->
          <img
            [src]="'../../assets/images/no_data.png'"
            *ngIf="
              data.charts.characteristic.chartData[selectedCategory] &&
              data.charts.characteristic.chartData[selectedCategory]
                .filterByCurrentlyEnrolled
            "
            [matTooltip]="filterByCurrentlyEnrolledText"
            [alt]="filterByCurrentlyEnrolledText"
          />
        </div>

        <ng-select
          [items]="ranks"
          [(ngModel)]="selectedRank"
          placeholder="Select a rank"
          [clearable]="false"
          [searchable]="false"
          class="chart-select"
          *ngIf="
            data.selectedChart == 'topBottomRank' &&
            data.charts.topBottomRank.chartData
          "
        ></ng-select>
      </div>
      <div
        class="kpi-goal-text"
        *ngIf="data.selectedChart != 'overall' && data.goalNumeric == null"
      >
        <div class="capital-kpi-goal-text">
          <a
            [routerLink]="getRouteForCog(metadata.KPI)"
            *ngIf="role == 'admin'"
            title="Set goal in Metric Settings"
            class="settings-link"
          >
            <em *ngIf="level == 'district'">No district goal set</em>
            <em *ngIf="level != 'district'">No school goal set</em>
          </a>
          <ng-container *ngIf="role != 'admin'">
            <em *ngIf="level == 'district'">No district goal set</em>
            <em *ngIf="level != 'district'">No school goal set</em>
          </ng-container>
        </div>
      </div>
    </div>
    <div
      class="no-data-available"
      [ngClass]="{ 'no-data-has-title': metadata && metadata.title }"
      *ngIf="
        (data.selectedChart == 'category' &&
          data.charts.category &&
          !data.charts.category.chartData) ||
        (data.selectedChart == 'trend' &&
          data.charts.trend &&
          !data.charts.trend.chartData) ||
        (data.selectedChart == 'calendar' &&
          data.charts.calendar &&
          !data.charts.calendar.chartData) ||
        (data.selectedChart == 'overall' &&
          data.charts.overall &&
          !data.charts.overall.chartData) ||
        (data.selectedChart == 'characteristic' &&
          data.charts.characteristic &&
          !data.charts.characteristic.chartData) ||
        (data.selectedChart == 'topBottomRank' &&
          level != 'school' &&
          data.charts.topBottomRank &&
          !data.charts.topBottomRank.chartData) ||
        (data.selectedChart == 'trendlineAlternate' &&
          data.charts.trendlineAlternate &&
          !data.charts.trendlineAlternate.chartData) ||
        (level == 'usage' &&
          data.charts.overall &&
          !data.charts.overall.chartData)
      "
    >
      <ng-container *ngIf="!isFreckleMetric">No data available</ng-container>
      <practice-data-unavailable
        *ngIf="isFreckleMetric"
      ></practice-data-unavailable>
    </div>
    <div
      class="overall"
      *ngIf="
        (data.selectedChart == 'overall' &&
          data.charts.overall &&
          data.charts.overall.chartData) ||
        (data.charts.overall &&
          data.charts.overall.chartData &&
          level === 'usage')
      "
    >
      <overall
        *ngIf="
          filterCategory &&
          filterValue &&
          filteredOverallChartData &&
          filteredOverallChartData[0]
        "
        [chartData]="filteredOverallChartData"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [trendSuffix]="data.trendSuffix"
        [title]="data.title"
        [upIsGood]="data.upIsGood"
        [color]="filteredOverallChartData[0].color"
        [entityLevel]="data.entityLevel"
        [overallSubtitle]="filteredOverallChartData.descriptor"
        [studentFirstName]="studentFirstName"
        [hideSubtitle]="!data.charts.trend"
        [roundTo]="data.roundTo"
        [filterSentence]="filterSentence"
        [isFreckleMetric]="isFreckleMetric"
      ></overall>
      <div
        class="no-data-available"
        [ngClass]="{ 'no-data-has-title': metadata && metadata.title }"
        *ngIf="
          filterCategory &&
          filterValue &&
          (!filteredOverallChartData || !filteredOverallChartData[0])
        "
      >
        <ng-container *ngIf="!isFreckleMetric">No data available</ng-container>
        <practice-data-unavailable
          *ngIf="isFreckleMetric"
        ></practice-data-unavailable>
      </div>
      <overall
        *ngIf="!filterCategory || !filterValue"
        [chartData]="data.charts.overall.chartData"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [trendSuffix]="data.trendSuffix"
        [title]="data.title"
        [upIsGood]="data.upIsGood"
        [color]="data.charts.overall.chartData[0].color"
        [entityLevel]="data.entityLevel"
        [overallSubtitle]="data.overallSubtitle"
        [studentFirstName]="studentFirstName"
        [hideSubtitle]="!data.charts.trend"
        [roundTo]="data.roundTo"
        [isFreckleMetric]="isFreckleMetric"
      ></overall>
    </div>
    <div
      class="chart tile-chart"
      [ngSwitch]="data.selectedChart"
      *ngIf="
        data.selectedChart != 'overall' &&
        data.charts[data.selectedChart] &&
        data.charts[data.selectedChart].chartData
      "
    >
      <stacked-column
        [chartData]="data.charts.category.chartData"
        [title]="data.title"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [level]="level"
        [metricId]="metadata.KPI"
        [studentMetricId]="
          metadata.studentKPIs && metadata.studentKPIs[0]
            ? metadata.studentKPIs[0].studentKPI
            : null
        "
        [entityId]="entityId"
        *ngSwitchCase="'category'"
      ></stacked-column>

      <line
        [chartData]="data.charts.trend.chartData"
        [goal]="data.goalNumeric"
        [goalText]="data.goalText"
        [categories]="data.charts.trend.categories"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [min]="data.charts.trend.min"
        [max]="data.charts.trend.max"
        [subTitle]="data.charts.trend.subtitle"
        [entityLevel]="data.entityLevel"
        [studentFirstName]="studentFirstName"
        [level]="level"
        [roundTo]="data.roundTo"
        [periodicity]="data.periodicity"
        *ngSwitchCase="'trend'"
      ></line>

      <horizontal-bar
        [chartData]="data.charts.characteristic.chartData[selectedCategory]"
        [goal]="data.goalNumeric"
        [goalText]="data.goalText"
        [min]="data.charts.characteristic.min"
        [max]="data.charts.characteristic.max"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [roundTo]="data.roundTo"
        [overall]="data.overall"
        [level]="level"
        [domainId]="data.domainId"
        [selectedCategory]="selectedCategory"
        [entityId]="entityId"
        *ngSwitchCase="'characteristic'"
      ></horizontal-bar>

      <bar
        [chartData]="data.charts.bar.chartData"
        [categories]="data.charts.bar.categories"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [studentFirstName]="studentFirstName"
        *ngSwitchCase="'bar'"
      ></bar>

      <rank-table
        [chartData]="data.charts.topBottomRank.chartData"
        [sortOrder]="selectedRank"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [isRestrictedUser]="role == 'restricted_user'"
        *ngSwitchCase="'topBottomRank'"
      ></rank-table>

      <calendar-tile
        [data]="data.charts.calendar"
        [suffix]="data.dataSuffix"
        *ngSwitchCase="'calendar'"
      ></calendar-tile>
    </div>
    <div class="chart-change-btns" *ngIf="!filterCategory || !filterValue">
      <view-select-buttons
        #ViewSelectBtns
        [chartNames]="getChartNames(data.charts)"
        [selectedChart]="data.selectedChart"
        (changeSelectedChart)="changeSelectedChart($event)"
        [domainId]="data.domainId"
        [metricId]="metadata.KPI"
        class="view-selector"
        *ngIf="level !== 'usage'"
      >
      </view-select-buttons>
    </div>
  </div>
  <div class="clear-filter-footer" *ngIf="filterCategory && filterValue">
    <p>Want to see broader data?</p>
    <button (click)="clearFilterEvent.emit()" mat-raised-button color="primary">
      Clear Filters
    </button>
  </div>
  <div class="loading-metric-data" *ngIf="loading">Loading metric data...</div>
  <div class="no-data-available" *ngIf="!loading && !data">
    <ng-container *ngIf="!isFreckleMetric">No data available</ng-container>
    <practice-data-unavailable
      *ngIf="isFreckleMetric"
    ></practice-data-unavailable>
  </div>
</div>
